import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const LogoutIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M22.25 12q-.02.57-.42.93l-.03.04-2.92 2.91a1.25 1.25 0 0 1-1.76-1.76l.86-.87H13a1.25 1.25 0 0 1 0-2.5h4.98l-.86-.87a1.25 1.25 0 1 1 1.76-1.76l2.92 2.9q.02.04.05.06.38.36.4.92m-6-7a1.25 1.25 0 0 1-2.5 0v-.5a.25.25 0 0 0-.25-.25H5a.75.75 0 0 0-.75.75v14c0 .41.34.75.75.75h8.5q.23-.02.25-.25V19a1.25 1.25 0 0 1 2.5 0v.5a2.75 2.75 0 0 1-2.75 2.75H5a3.25 3.25 0 0 1-3.25-3.08V5c0-1.8 1.46-3.25 3.25-3.25h8.5a2.75 2.75 0 0 1 2.75 2.75z" />
    </SvgIcon>
);
